import { render, staticRenderFns } from "./Movimiento.vue?vue&type=template&id=56699633&scoped=true"
import script from "./Movimiento.vue?vue&type=script&lang=js"
export * from "./Movimiento.vue?vue&type=script&lang=js"
import style0 from "./Movimiento.vue?vue&type=style&index=0&id=56699633&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56699633",
  null
  
)

export default component.exports